export default __webpack_public_path__ + "static/media/Lightsaber Ki-Adi AOTC - Img - Wip 1_10.88007c1f.jpg";